// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1CypherVersionConfig = {
  CypherVersion5: 'cypher-5',
  CypherVersion25: 'cypher-25',
} as const;
export type V1CypherVersionConfig =
  (typeof V1CypherVersionConfig)[keyof typeof V1CypherVersionConfig];

export function instanceOfV1CypherVersionConfig(value: any): boolean {
  for (const key in V1CypherVersionConfig) {
    if (Object.prototype.hasOwnProperty.call(V1CypherVersionConfig, key)) {
      if (
        V1CypherVersionConfig[key as keyof typeof V1CypherVersionConfig] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function V1CypherVersionConfigFromJSON(
  json: any,
): V1CypherVersionConfig {
  return V1CypherVersionConfigFromJSONTyped(json, false);
}

export function V1CypherVersionConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1CypherVersionConfig {
  return json as V1CypherVersionConfig;
}

export function V1CypherVersionConfigToJSON(
  value?: V1CypherVersionConfig | null,
): any {
  return value as any;
}

export function V1CypherVersionConfigToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1CypherVersionConfig {
  return value as V1CypherVersionConfig;
}
